module.exports = {"bewizr-agenda":{"empty":{"title":"Aucune activité","detail":"Vous n’avez aucune activité planifiée."}}}